import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Authorization from '../../Authentication/Authorization'
import { FlipCard, FlipCardContainer } from '../../components/FlipCard'
import ProtectedRoute from '../../components/ProtectedRoute'
import GatewayType from '../GatewayType'
import Database from './Database'
import Log from './Log'
import Version from './Version'

const baseRoute = '/info'

const subTabs = [
  { path: baseRoute + '/version', title: 'Version', permissions: Authorization.info.version, component: Version },
  { path: baseRoute + '/database', title: 'Database', permissions: Authorization.info.database, component: Database },
  { path: baseRoute + '/log', title: 'Log', permissions: Authorization.info.LogFile, component: Log },
]

const Info: GatewayType = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      {subTabs.map((tab) => (
        <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
      ))}
      <Route path={match.path}>
        <FlipCardContainer>
          <FlipCard headerText='Version' size='xl' flipFrontContent={<Version classes='text-white' searchable={false} sortable={false} useCaption={false} />} />
        </FlipCardContainer>
      </Route>
    </Switch>
  )
}

Info.subTabs = subTabs

export default Info
